import React, { useState } from 'react';
import autoImage from '../assets/carro.jpg';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import '../styles/disenosegurosbase.css';


export default function SeguroDeAuto() {
  const [genero, setGenero] = useState("");
  const [edad, setEdad] = useState("");
  const [modelo, setModelo] = useState("");
  const [version, setVersion] = useState("");
  const [año, setAño] = useState("");
  const [marca, setMarca] = useState("");
  const [correo, setCorreo] = useState("");
  const [nombre, setNombre] = useState("");
  const [numero, setNumero] = useState("");
  const [tipoAuto, setTipoAuto] = useState("");


  const navigate = useNavigate();

  const handleSubmit = async () => {
    // Validaciones 
    if (!nombre || !edad || !genero || !modelo || !version || !año || !marca || !correo || !numero || !tipoAuto) {
      Swal.fire('Campos incompletos', 'Por favor llena todos los campos obligatorios.', 'warning');
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 100) {
      return;
    }

    if (isNaN(año) || año < 1900 || año > new Date().getFullYear()) {
      Swal.fire('Ingresa un año de vehículo válido','','warning');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(correo)) {
      Swal.fire("Ingresa un correo electrónico válido");
      return;
    }

    if (numero.length < 8 || numero.length > 15) {
      Swal.fire("Ingresa un número de teléfono válido");
      return;
    }
  // Validar correo
  const correoValido = /^[a-zA-Z0-9._%+-]+@(gmail|hotmail|outlook|yahoo)\.com$/;
  if (!correoValido.test(correo)) {
    Swal.fire("Por favor, ingresa un correo válido de @gmail.com, @hotmail.com, @outlook.com o @yahoo.com.");
    return;
  }

    try {
      const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/citaseguroauto`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nombre: nombre,
          Edad: edad,
          Genero: genero,
          Modelo: modelo,
          Marca: marca,
          Version: version,
          Año: año,
          TipoAuto: tipoAuto,
          Correo: correo,
          Numero: numero
        }),
      });
      console.log(nombre)
      console.log(edad)
      console.log(genero)
      console.log(tipoAuto)
      console.log(correo)
      console.log(numero)
      const result = await response.json();
      console.log(result);
      Swal.fire({
        title: "Gracias!Nos pondremos en contacto pronto!",
        icon: "success",
        draggable: true
      });
    } catch (error) {
      console.error("Error al enviar los datos", error);
      Swal.fire("Ocurrió un error al enviar los datos");
    }
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="seguro-back"
      >
        ← Regresar al Menú
      </button>
      <div className="seguro-container">
        <div 
          className="seguro-left"
          style={{ backgroundImage: `url(${autoImage})` }}
        >
          <div className="seguro-overlay">
            <h1>¿Listo para proteger tu auto?</h1>
            <p>
              Completa este formulario y obtén una cotización personalizada para tu seguro de auto. Rápido, fácil y sin compromiso.
            </p>
          </div>
        </div>

        <div className="seguro-form">
          <h2>Cotización Seguro de Auto</h2>

          <label>Nombre:</label>
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />

          <label>Edad:</label>
          <input
            type="number"
            value={edad}
            onChange={(x) => {
              const valor = x.target.value;
              if (valor === "" || (Number(valor) >= 1 && Number(valor) <= 99)) {
                setEdad(valor);
              }
            }}
            min="1"
            max="99"
          />

          <label>Género:</label>
          <select value={genero} onChange={(e) => setGenero(e.target.value)}>
            <option value="">Selecciona</option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
          </select>

          <h3>Datos del Vehículo:</h3>

          <label>Modelo del auto:</label>
          <input type="text" value={modelo} onChange={(e) => setModelo(e.target.value)} />

          <label>Marca del auto:</label>
          <input type="text" value={marca} onChange={(e) => setMarca(e.target.value)} />

          <label>Versión:</label>
          <input type="text" value={version} onChange={(e) => setVersion(e.target.value)} />

          <label>Año del vehículo:</label>
          <input type="number" value={año} onChange={(e) => setAño(e.target.value)} />

          <label>Tipo de vehículo:</label>
          <select value={tipoAuto} onChange={(e) => setTipoAuto(e.target.value)}>
            <option value="">Selecciona el tipo de vehículo</option>
            <option value="Nacional">Nacional</option>
            <option value="Fronterizo">Fronterizo</option>
          </select>
          
          <div className="auto-type-explanation">
            <div className="explanation-card">
              <h4>🚗 Nacional</h4>
              <p>Vehículo comprado en México, con placas mexicanas y que circula principalmente dentro del territorio nacional.</p>
            </div>
            <div className="explanation-card">
              <h4>🌎 Fronterizo</h4>
              <p>Vehículo que cruza frecuentemente la frontera entre México y Estados Unidos, requiere cobertura especial para ambos países.</p>
            </div>
          </div>

          <label>Correo de contacto:</label>
          <input type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} />

          <label>Número de teléfono:</label>
          <input type="tel" value={numero} onChange={(e) => setNumero(e.target.value)} />

          <button onClick={handleSubmit} className="seguro-btn">Enviar</button>

          <p
            onClick={() => navigate("/pantallaCIT")}
            className="seguro-link"
          >
            ¿Quieres atencion mas directa? Agenda tu cita aquí!
          </p>
        </div>
      </div>
    </>
  );
}

